export default __webpack_public_path__ + "static/media/company.69f150b1.jpg";